import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as DeliveryAssociate from '../../../../../service/master/DeliveryAssociateServices';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTES } from "../../../../../constant/routeConstant";
import moment from 'moment';

const useDetailDeliveryAssociate = () => {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [data, setData] = useState({});
  const [driverProfile, setDriverProfile] = useState({})
  const [fleetDetail, setFleetDetail] = useState({})
  const [addtionalProofs, setAddtionalProofs] = useState([]);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])
  const dispatch = useDispatch()

  console.log(location);

  const _changeTab = (tab) => {
    switch (tab) {
      case 1:
        setTab1(true);
        setTab2(false);
        break;
      case 2:
        setTab1(false);
        setTab2(true);
        break;

      default:
        break;
    }
  }

  const doGetManagementHistoryList = async (id) => {
    try {
        const response = await DeliveryAssociate.getManagementHistoryList(token, null, dispatch, id);
        if (response && response.ok) {
            const data = response.data
            const reorderedData = []

            for (let i = data.length - 1; i >= 0; i--) {
                const element = data[i];
                reorderedData.push(element)
            }

            setManagementHistoryList(reorderedData)
        }
    } catch (error) {
        console.log(error)
    }
}

  const _handleBack = () => {
    navigate(ROUTES.DELIVERY_ASSOCIATE.LIST)
  }

  const _toEdit = () => {
    navigate(ROUTES.DELIVERY_ASSOCIATE.EDIT, {
      state: {
        id: location?.state?.id, 
        prevPage: location?.pathname
      } 
    });
  }

  const _onDelete = () => {
    setModalDeleteOpen(true)
  }

  useEffect(() => {
    getDetail(location?.state?.id);
    doGetManagementHistoryList(location?.state?.id)
    
    // eslint-disable-next-line
  },[]);

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
        "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
        return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
        return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
}

const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
}

  const getDetail = async (id) => {
    const { ok, data } = await DeliveryAssociate.detail(token, id);
    
    if (ok) {
      setData(data);
      setDriverProfile(data?.driver_profile);
      setFleetDetail(data?.fleet_detail);
      setAddtionalProofs(data?.additional_proofs);
    }
  }

  const doDeleteDA = async(id, updatedAt) =>{
    let body = {
      updated_at: updatedAt
    }

    try {
      const res = await DeliveryAssociate.deleteDeliveryAssociate(token, id, body)
      if (res.ok) {
        setSuccessModalOpen(true)
        setModalDeleteOpen(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return {
    tab1,
    tab2,
    data,
    driverProfile,
    fleetDetail,
    addtionalProofs,
    modalDeleteOpen,
    _changeTab,
    _handleBack,
    _toEdit,
    _onDelete,
    setModalDeleteOpen,
    doDeleteDA,
    navigate,
    successModalOpen,
    managementHistoryList,
    convertTimestamp,
    convertToTime
  }
}

export default useDetailDeliveryAssociate;